import {useState} from 'react';
import {SearchFilter} from "../../platform/search/PlatformSearch";

/**
 * Dwustanowy filtr-checkbox zgodny z interfejsem SearchFilterManager platformowego useSearch
 * (useSearch reaguje deep-compare na currentFilterOrNull, więc zwykły stan Reacta wystarcza).
 * Zaznaczony → parametr GET o nazwie [id] i wartości "true"; odznaczony → filtr nieaktywny.
 * Celowo app-level: platform/search to współdzielony kod read-only.
 */
export function useCheckboxFilterManager(id: string, humanFriendlyName: string) {
    const [checked, setChecked] = useState(false);

    const currentFilterOrNull: SearchFilter | null = checked ? {
        id: id,
        humanFriendlyName: humanFriendlyName,
        value: "true",
        humanFriendlyTextualValue: "Tak"
    } : null;

    return {
        id,
        checked,
        setChecked,
        humanFriendlyName,
        currentFilterOrNull,
        reset: () => setChecked(false),
    };
}
